import { useState, useEffect } from 'react';

import { getAllResponses } from '../../api/responses';

import { filtersToQueryString } from '../../helpers/filtering';

import Table from '../../components/table/table';
import { COLUMNS } from '../../config/response';

const Responses = () => {
  const [loading, setLoading] = useState(false);
  const [responsesData, setResponsesData] = useState(null);
  const [meta, setMeta] = useState({});

  const fetchData = async (page, filters = {}, search) => {
    const filtersString = filtersToQueryString(filters, search);
    const data = await getAllResponses(page, filtersString);

    setResponsesData(data.items);
    setMeta(data.meta);
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      await fetchData(1);
    })();
  }, []);

  if (loading || !responsesData) return <main className="th-main"></main>;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <span className="active">Responses</span>
          </h2>
        </header>
        <section className="view-container">
          <Table
            columns={COLUMNS}
            data={responsesData}
            meta={meta}
            hasViewBar
            fetchData={(p, f, s) => fetchData(p, f, s)}
          />
        </section>
      </section>
    </main>
  );
};

export default Responses;
